import React from 'react';
import { useWatch } from 'react-hook-form';
import {
    IOrderSale,
    REQUIRE_SUPPLEMENT,
    SUPPLEMENT_CODE,
} from '../../order-sale-form';
import { RHTextField } from '../../../../../../../dum';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function SupplementCodeInput() {
    const requireSupplement = useWatch({
        name: REQUIRE_SUPPLEMENT,
    }) as IOrderSale['require_supplement'];

    return (
        <RHTextField
            disabled={!requireSupplement}
            name={SUPPLEMENT_CODE}
            label={shortLabel(FIELD_LABELS.supplement_code)}
        />
    );
}
